export default __webpack_public_path__ + "static/media/night-sound.321b6f8e.mp3";